import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/finance/_finance/accounting/')({
  beforeLoad: () => {
    throw redirect({ to: '/clearing/finance/accounting/account' });
  },
  preload: false,
});
